import React from 'react';
import { isFunction } from 'lodash';
import { Box, Button } from '@chakra-ui/react';

interface RetryControlsProps {
  handleRetry?: () => void;
  handleDelete: () => void;
}

export const RetryControls: React.FC<RetryControlsProps> = ({
  handleRetry,
  handleDelete,
}) => (
  <Box pl={2} ml="auto">
    {isFunction(handleRetry) && (
      <Button variant="text" size="sm" onClick={handleRetry} mr={2}>
        Retry
      </Button>
    )}
    <Button
      variant="text"
      size="sm"
      color="R.80 !important"
      onClick={handleDelete}
    >
      Delete
    </Button>
  </Box>
);
